import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class LogoutService {
    constructor(private authService: AuthService, private router: Router) {}

    /**
     * Logout dengan hit API dan redirect ke login
     */
    logoutAndRedirect(): void {
        this.authService.signOut().subscribe({
            next: () => {
                console.log('Logout berhasil');
                // Redirect ke login page
                this.router.navigate(['/sign-in'], { replaceUrl: true });
            },
            error: (err) => {
                console.error('Logout error:', err);
                // Tetap redirect meskipun error
                this.router.navigate(['/sign-in'], { replaceUrl: true });
            },
        });
    }
}
